import { all, fork, put, takeLatest } from "redux-saga/effects";
import actions from "../actions";
import CONSTANTS from "../CONSTANTS";
import { formatByIdSaga } from "src/store/helpers/formatByIdSaga";
import { toast } from "react-toastify";

export const DOC_URL = "/services/rcp/profile/appointment/doctor/";
export function* getMyDoctor() {
  yield takeLatest(CONSTANTS.GET_MAIN_MY_DOCTOR, function* (action) {
    try {
      yield put(actions.setMyDoctor(undefined));
      const urlExtension = `?policyId=${action.payload?.policyId}`;

      const url = DOC_URL + "GetMyDoctor" + urlExtension;
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;
      yield put(actions.setMyDoctor(data));
    } catch (e) {
      yield put(actions.setMyDoctor(undefined));
      console.error(e);
    }
  });
}
export function* getPlannedVisitsDoctor() {
  yield takeLatest(
    CONSTANTS.GET_MAIN_PLANNED_VISITS_DOCTOR,
    function* (action) {
      try {
        yield put(actions.setPlannedVisitsDoctor(undefined));

        const url = DOC_URL + "PlannedVisitsDoctor?policyId=" + action.payload;
        const res = yield window.mainAxios.get(url).then((r) => r.data);
        // console.log(res)
        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };

        const data = res.data;

        yield put(actions.setPlannedVisitsDoctor(data));
      } catch (e) {
        yield put(actions.setPlannedVisitsDoctor([]));
        console.error(e);
      }
    }
  );
}
export function* getCancelReservation() {
  yield takeLatest(CONSTANTS.GET_MAIN_CANCEL_RESERVATION, function* (action) {
    try {
      yield put(actions.setDeleteReservation(null));

      const url = DOC_URL + "CancelReservation";
      const res = yield window.mainAxios
        .post(url, action.payload)
        .then((x) => x.data);

      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      const message = yield formatByIdSaga(
        "notifications.successfullyCanceled"
      );
      toast.success(message);
      yield put(
        actions.setUpdatePlannedVisitsDoctor(action.payload?.ReservationId)
      );
      yield put(actions.setServiceCenterUpdateCounter());
      yield put(actions.setDeleteReservation(true));
    } catch (e) {
      const message = yield formatByIdSaga(
        "notifications.couldntCancelConsultation"
      );
      toast.error(message);

      yield put(actions.setDeleteReservation(false));
    }
  });
}
export function* getAddReservationDocuments() {
  yield takeLatest(
    CONSTANTS.GET_MAIN_ADD_RESERVATION_DOCUMENTS,
    function* (action) {
      try {
        yield put(actions.setAddReservationDocuments(null));

        const formData = new FormData();
        formData.append("reservationId", action.payload.ReservationId);
        formData.append("patientComment", action.payload.PatientComment);

        const doctorPrescriptionDocumentsArray = Array.from(
          action.payload.DoctorPrescriptionDocuments
        );
        const researchResultsDocumentsArray = Array.from(
          action.payload.ResearchResultsDocuments
        );

        doctorPrescriptionDocumentsArray.forEach((file, _) => {
          formData.append(`DoctorPrescriptionDocuments`, file);
        });

        researchResultsDocumentsArray.forEach((file, _) => {
          formData.append(`ResearchResultsDocuments`, file);
        });

        const url = DOC_URL + "AddReservationDocuments";
        const res = yield window.mainAxios
          .post(url, formData)
          .then((x) => x.data);

        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };

        const message = yield formatByIdSaga(
          "notifications.informationSuccessfullyShared"
        );
        toast.success(message);
        yield put(actions.setAddReservationDocuments(true));
      } catch (e) {
        const message = yield formatByIdSaga(
          "notifications.couldntshareDetails"
        );
        toast.error(message);

        yield put(actions.setAddReservationDocuments(false));
      }
    }
  );
}

export default function* doctorSaga() {
  yield all([
    fork(getMyDoctor),
    fork(getPlannedVisitsDoctor),
    fork(getCancelReservation),
    fork(getAddReservationDocuments),
  ]);
}
